import Heading from "components/UI/atoms/Heading";
import { Box, Flex, Input } from "@chakra-ui/react";
import { useUI } from "providers/UIProvider";
import Icon from "components/UI/atoms/Icon";
import Button from "components/UI/atoms/Button";
import { useState, useRef } from "react";

interface ILaundryDiscount {
    discountTypes: { id: number, name: string }[]
    handleAddDiscount: any
    handleDeleteDiscount: any
}


const LaundryDiscount: React.FC<ILaundryDiscount> = ({ discountTypes, handleAddDiscount, handleDeleteDiscount }) => {
    const { T } = useUI();
    const [showInput, setShowInput] = useState(false);
    const [discount, setDiscount] = useState({ id: 0, name: "" });
    // const [discounts, setDiscounts] = useState<string[]>([]);
    const discountRef = useRef<any>()

    const validateDiscount = () => {
        if ((!discount?.name) || (discountTypes.length !== 0 && discountTypes.some((item) => item?.name === discount?.name))) {
            return true;
        }
    };


    return (
        <Flex mt={"40px"} mb={"40px"} flexDirection="column">
            <Heading variant="bold" size={"sm"} title={T("laundry.discount.title")} />

            <Flex style={{ flexDirection: "column" }} gap={5} marginTop="5" key={discount?.id}>
                <>
                    {discountTypes.map((discount: any) => <Flex gap={10} key={discount?.id}>
                        <Input
                            readOnly
                            value={discount?.name}
                            style={{
                                width: "90%",
                                height: "3.75rem",
                                color: "#08BA36",
                                fontSize: "16px",
                                fontWeight: "600",
                                pointerEvents: "none"
                            }} />
                        <Box style={{ cursor: "pointer" }} onClick={() => handleDeleteDiscount(discount?.name)}>
                            <Flex style={{
                                backgroundColor: "#046CEC1A",
                                height: "60px",
                                width: "60px",
                                borderRadius: "100px",
                                justifyContent: "center",
                                alignItems: "center"
                            }}>
                                <Icon name="delete_forever" iconStyles={{ width: "24px", height: "24px", }} />
                            </Flex>
                        </Box>
                    </Flex>)
                    }

                    {showInput && <Flex gap={14}>
                        <Input
                            ref={discountRef}
                            value={discount?.name}
                            onChange={(e) => setDiscount({ ...discount, id: 0, name: e.target.value })}
                            autoFocus
                            style={{ width: "90%", height: "3.75rem" }}
                        />

                        <Button isDisabled={validateDiscount()} style={{ background: "red", borderRadius: "100px", width: "15px", height: "50px" }}
                            leftIcon={

                                <Icon name="doneIcon" iconStyles={{ width: "60px", height: "60px", }} />

                            }
                            text=""
                            onClick={() => {
                                handleAddDiscount(discount)
                                setDiscount({ id: 0, name: "" })
                            }}>

                        </Button>
                        {/* </Box> */}
                    </Flex>}
                </>
            </Flex>

            <Button mt="5" style={{
                color: "#00000099",
                backgroundColor: "#E9F2FD",
                height: "3.75rem",
                borderStyle: "dashed",
                fontWeight: "500",
                fontSize: "16px"
            }}
                text={T("loundry.add.new.discount")}
                onClick={() => setShowInput(!showInput)} />

        </Flex >
    )
};

export default LaundryDiscount;